<template>
  <svg :width="size" :height="size" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M9 9.75V15.75L6 12.75"
      :stroke="color"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M9 15.75L12 12.75"
      :stroke="color"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M3.29477 11.4517C2.68222 10.9159 2.20264 10.2449 1.8939 9.49192C1.58516 8.7389 1.45571 7.92441 1.51579 7.11277C1.57586 6.30114 1.82381 5.51458 2.24006 4.81522C2.6563 4.11586 3.22943 3.52285 3.9142 3.08302C4.59897 2.64318 5.37662 2.36857 6.18574 2.28088C6.99486 2.19318 7.81329 2.29479 8.57639 2.57769C9.3395 2.86059 10.0264 3.31703 10.5828 3.91097C11.1392 4.5049 11.5499 5.22007 11.7825 5.99998H13.125C13.8541 5.99989 14.5635 6.23588 15.1473 6.67262C15.731 7.10937 16.1577 7.72341 16.3634 8.42284C16.569 9.12228 16.5427 9.86951 16.2883 10.5527C16.0339 11.2359 15.5651 11.8184 14.952 12.213"
      :stroke="color"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>

<script>
export default {
  name: 'DownloadCloudLightIcon',
  props: {
    color: {
      type: String,
      default: '#E10009'
    },
    size: {
      type: String,
      default: '18'
    }
  }
}
</script>
